<template>
  <div class="collapsible-section">
    <div class="collapsible-section__header">
      <slot
        name="toggle"
        :toggle="toggle"
        :is-visible="isVisible"
      >
        <div class="collapsible-section__toggle">
          <BasicButton
            appearance="toggle"
            @click="toggle"
          >
            <span v-text="title" />
            <div class="collapsible-section__arrow">
              <ArrowIcon :direction="isVisible ? 'top' : 'bottom'" size="18" />
            </div>
          </BasicButton>
        </div>
      </slot>
      <div class="collapsible-section__counter" v-text="counter" />
    </div>
    <TransitionExpand>
      <div
        v-if="isVisible"
        class="collapsible-section__content"
        :class="bem('collapsible-section__content', { withLine, noMargin })"
        key="content"
      >
        <slot />
      </div>
    </TransitionExpand>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import ArrowIcon from 'src/components/icons/ArrowIcon/ArrowIcon.vue';
  import TransitionExpand from 'src/components/transitions/TransitionExpand/TransitionExpand.vue';

  export default {
    name: 'CollapsibleSection',
    components: { ArrowIcon, TransitionExpand, BasicButton },
    props: {
      title: {
        type: String,
      },
      counter: Number,
      visible: {
        type: Boolean,
        default: false,
      },
      withLine: {
        type: Boolean,
        default: true,
      },
      withTitleHover: Boolean,
      noMargin: Boolean,
    },
    emits: ['toggle'],
    data() {
      return {
        isVisible: this.visible,
      }
    },
    methods: {
      bem,
      toggle() {
        this.isVisible = !this.isVisible;
        this.$emit('toggle', this.isVisible);
      }
    }
  }
</script>